module.exports = __webpack_public_path__ + "static/media/mott_catalog_page1.c033ca05.png";